import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { servicesApiKeyStore } from '../../../../api/masters/services-api-key-store';
import { LoadingIndicator } from '../../../../components/loading-indicator.component';

interface Workorder {
  unitID: number;
  serviceID: number;
}

interface CreateWorkorderFormProps {
  name?: string;
  unitID?: number;
  isOrginalService?: boolean;
  workOrderID?: number;
  handleSetSelectedServiceId: (value: number, fastFieldFormIDValue: number) => void;
}
export const ServiceList = ({
  name,
  unitID,
  isOrginalService,
  workOrderID,
  handleSetSelectedServiceId,
}: CreateWorkorderFormProps) => {
  const [currentServiceID, setCurrentServiceID] = useState<number>(0);
  const { data, isLoading } = useLoadData<ApiResponse<any>>(
    servicesApiKeyStore.getProjectContractedServices(!workOrderID ? 0 : workOrderID)
  );
  useEffect(() => {
    if (isOrginalService) {
      setCurrentServiceID(0);
    }
  }, [isOrginalService]);

  const handleFilterSelected = (event: any) => {
    const selectedValueID = event.target.value as number;

    const selectedItem = data?.data?.find((item: any) => item.serviceID === selectedValueID);
    const newFastFieldFormID = selectedItem?.fastFieldFormID || null;

    handleSetSelectedServiceId(selectedValueID, newFastFieldFormID);

    setCurrentServiceID(selectedValueID);
  };

  return (
    <>
      {isLoading && <LoadingIndicator isLoading={isLoading} />}
      <FormControl fullWidth style={{ marginBottom: '8px' }}>
        <InputLabel size="small" id="demo-simple-select-label">
          Select Service
        </InputLabel>
        <Select
          // style={{ width: '200px' }}
          size="medium"
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={currentServiceID}
          label="Mapping Type"
          onChange={handleFilterSelected}
        >
          {data &&
            data.data.map((item: any) => (
              <MenuItem key={`${item.serviceID}-${item.serviceID}`} value={item.serviceID}>
                {item.serviceName}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </>
  );
  // <SelectChainItem config={selectConfig} value={selectedService} onSelect={handleFilterSelected} />;
};
